import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "./config";

const Cellgroups = ({ searchQuery }) => {

    const [cellGroupsData, setCellGroupsData] = useState([]);
    const [hoveredCard, setHoveredCard] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorLoading, setErrorLoading] = useState(false);
    const navigate = useNavigate();

    // Hover state style
    const hoverStyle = {
        backgroundColor: '#f0f0f0',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)'
    };


    useEffect(() => {
        const asyncFetch = async () => {
            try {
                const userId = await localStorage.getItem("UserID");

                let res = await fetch(`${API_URL}/smallgroups/small-groups/${userId}`, {
                    method: "get",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                let responseJson = await res.json();
                setCellGroupsData(responseJson);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setErrorLoading(true);
            }
        }

        asyncFetch();

    }, []);

    // Filtered data calculation
    const filteredData = useMemo(() => {
        if (!searchQuery) return cellGroupsData;

        const query = searchQuery.toLowerCase();
        return cellGroupsData.filter(group =>
            group.name.toLowerCase().includes(query) ||
            group.location.toLowerCase().includes(query)
        );
    }, [cellGroupsData, searchQuery]);

    const handleCardClick = (cellObj) => {
        localStorage.setItem("SelectedGroup", JSON.stringify(cellObj));
        navigate(`/cellgroup`);
    };


    return (
        <div>
            <h4 style={{ textAlign: 'center', fontSize: '17px', color: '#1a6363', marginBottom: "60px" }}>
                Be part of a Home Group
            </h4>
            {loading ? (
                <p >Loading...</p>
            ) : errorLoading ? (
                <p >Connection error, check your network connection</p>
            ) : filteredData.length === 0 ? (
                <p >No home groups found {searchQuery && ` for "${searchQuery}"`}</p>
            ) : (
                <div className="block">
                    {filteredData.map((group) => (
                        <div
                            key={group.id}
                            style={{
                                border: '1px solid #1a6363',
                                borderRadius: '10px',
                                padding: '15px',
                                margin: '10px 0',
                                backgroundColor: '#f9f9f9',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                ...(hoveredCard === group.id && hoverStyle)
                            }}
                            onMouseEnter={() => setHoveredCard(group.id)}
                            onMouseLeave={() => setHoveredCard(null)}
                            onClick={() => handleCardClick(group)}
                        >
                            <h5 style={{ margin: '0', fontSize: '16px', color: '#1a6363' }}>
                                {group.name}
                            </h5>
                            <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                                <strong>Address:</strong> {group.location}
                            </p>
                            <p style={{ margin: '5px 0', fontSize: '14px', color: '#555' }}>
                                {group.joined ? "Joined" : "Not Joined"}
                            </p>
                        </div>
                    ))}
                </div>
            )}
            <br></br>
        </div>
    );
};

export default Cellgroups;